export const weekDayKeys = [
  'INTEGRATIONS.DAYS.SUN',
  'INTEGRATIONS.DAYS.MON',
  'INTEGRATIONS.DAYS.TUE',
  'INTEGRATIONS.DAYS.WED',
  'INTEGRATIONS.DAYS.THU',
  'INTEGRATIONS.DAYS.FRI',
  'INTEGRATIONS.DAYS.SAT',
];

// Define your allowed range here
export const MIN_INTERVAL = 1;
export const MAX_INTERVAL = 52;
